export default __webpack_public_path__ + "static/media/banner-welcome-l.249a36bd.png";